'use strict';

/**
 * Maps the way we store it in the db to user-friendly name for role
 */
module.exports = {
  Host: 'Host',
  Admin: 'Admin',
  'NY': 'New York Leads',
  'MA': 'Massachusetts Leads',
  'DC': 'Washington DC Leads',
  'CA': 'California Leads',
  'Closer': 'Closer',
  'PrimaryAssignee': 'Primary Assignee',
  'Venue Acquisition': 'Venue Acquisition',
  'Profile Creation': 'Profile Creation',
  'Venue Admin': 'Venue Admin',
  'OOM Admin': 'OOM Admin'
};